import { createClient } from "@supabase/supabase-js";

// Browser-side Supabase client. Uses the public anon (publishable) key; all
// access is constrained by Row Level Security so students read only their own
// rows. The service-role key is NEVER used here — it lives only in Workers.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Surfaces a clear console error in dev/preview if env wiring is missing,
  // rather than a cryptic network failure deep in the auth flow.
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — auth and DB calls will fail."
  );
}

export const supabase = createClient(url ?? "", anonKey ?? "", {
  auth: {
    // Persist the session in localStorage so a logged-in student stays logged
    // in across reloads; auto-refresh keeps the access token fresh.
    persistSession: true,
    autoRefreshToken: true,
    // Required for the magic-link flow: Supabase puts the session tokens in the
    // URL fragment on redirect back to the app; this parses + stores them.
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});
